
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/integrations/supabase/types";

/**
 * Force-fetches all suggestions using the database function
 * This is a last resort method when all other approaches fail
 * @param setSuggestions - State setter function for suggestions
 * @returns Promise that resolves when the operation is complete
 */
export const fetchAllSuggestionsRaw = async (
  setSuggestions: (suggestions: Tables<'suggestions'>[]) => void
): Promise<void> => {
  try {
    console.log('Attempting to fetch suggestions with RPC method...');
    
    const { data, error } = await supabase.rpc('get_all_suggestions');
    
    console.log('RPC query result:', { data, error });
    
    if (error) {
      console.error('RPC query error:', error);
      return;
    }
    
    if (Array.isArray(data) && data.length > 0) {
      console.log(`RPC query found ${data.length} results`);
      setSuggestions(data);
    } else {
      console.log('RPC query found no results');
    }
  } catch (error) {
    console.error('Error in RPC query:', error);
  }
};
